import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import "../../styles/Blog.css";
import NotFound from "../NotFound";
import strings from "../../blog/strings";
import useBlogHead from "../../blog/seo";
import { profilePageLd, breadcrumbLd } from "../../blog/schema";
import { getAuthor, postsByAuthor, langConfig, absolute } from "../../blog/data";
import { Breadcrumbs, PostCard } from "./parts";

function BlogAuthor({ lang }) {
  const { author: slug } = useParams();
  const author = getAuthor(lang, slug);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [slug]);

  if (!author) return <NotFound />;

  const t = strings(lang);
  const cfg = langConfig(lang);
  const posts = postsByAuthor(lang, slug);
  const title = `${author.name} — ${author.role || t.authorPrefix} | ${cfg.title}`;
  const description = author.bioText.slice(0, 160);
  const crumbs = [
    { name: t.home, path: "/" },
    { name: cfg.title, path: cfg.indexPath },
    { name: author.name },
  ];

  return (
    <div className="blog">
      <BlogAuthorHead
        lang={lang}
        cfg={cfg}
        author={author}
        title={title}
        description={description}
        posts={posts}
        crumbs={crumbs}
      />

      <div className="blog-shell blog-shell-article">
        <Breadcrumbs lang={lang} items={crumbs} />

        <header className="blog-index-header">
          <h1>{author.name}</h1>
          {author.role && <p className="blog-lead">{author.role}</p>}
        </header>

        <div
          className="blog-content"
          /* Bio pochodzi z content/blog/authors/**.md (build-time) */
          dangerouslySetInnerHTML={{ __html: author.bioHtml }}
        />

        {author.credentials.length > 0 && (
          <section className="blog-credentials" aria-labelledby="blog-credentials-heading">
            <h2 id="blog-credentials-heading">{t.aboutAuthor}</h2>
            <ul>
              {author.credentials.map((c) => (
                <li key={c}>{c}</li>
              ))}
            </ul>
          </section>
        )}

        {posts.length > 0 && (
          <section className="blog-author-posts" aria-labelledby="blog-author-posts-heading">
            <h2 id="blog-author-posts-heading">{t.moreFromAuthor}</h2>
            <div className="blog-list">
              {posts.map((post) => (
                <PostCard key={post.slug} lang={lang} post={post} headingLevel={3} />
              ))}
            </div>
          </section>
        )}
      </div>
    </div>
  );
}

function BlogAuthorHead({ lang, cfg, author, title, description, posts, crumbs }) {
  useBlogHead({
    title,
    description,
    canonical: author.url,
    lang,
    locale: cfg.locale,
    ogType: "website",
    jsonLd: [
      profilePageLd(author, posts),
      breadcrumbLd(
        crumbs.map((c) => ({ name: c.name, url: c.path ? absolute(c.path) : author.url }))
      ),
    ],
  });
  return null;
}

export default BlogAuthor;
